import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-floating mb-4" }
const _hoisted_2 = { class: "my-3 text-danger" }
const _hoisted_3 = { class: "d-grid gap-2 d-md-flex justify-content-md-end mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_bad_response_viewer = _resolveComponent("bad-response-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_currency_input, {
        ref: "uiAmount",
        description: "actual amount",
        elementId: "statePensionAmount",
        onEntered: _ctx.onSaveClicked,
        maxValue: 15000
      }, null, 8, ["onEntered"])
    ]),
    _withDirectives(_createElementVNode("p", _hoisted_2, _cache[2] || (_cache[2] = [
      _createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1),
      _createTextVNode(" Amount not valid. ")
    ]), 512), [
      [_vShow, _ctx.showValidation]
    ]),
    _createVNode(_component_bad_response_viewer, { ref: "badResponseViewer" }, null, 512),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link text-dark text-decoration-none me-md-2",
        "aria-label": "Close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancelClicked && _ctx.onCancelClicked(...args)))
      }, " Cancel "),
      _createElementVNode("button", {
        type: "button",
        class: "btn px-5 btn-secondary",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSaveClicked && _ctx.onSaveClicked(...args)))
      }, " Update ")
    ])
  ], 64))
}